/**
 * Hero gọn + "Cách hoạt động" + "Dùng để làm gì?" — phần tĩnh của trang rải link.
 *
 * Hero cố ý KHÔNG lặp lại tiêu đề to như bản cũ: nó chiếm chỗ mà không thêm thông
 * tin, đẩy ô dán link xuống dưới nếp gấp trên màn hình điện thoại.
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLink,
    faShare,
    faCoins,
    faUsers,
    faShoppingBag,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const FLOW = [
    { icon: faLink, label: "Dán link" },
    { icon: faShare, label: "Chia sẻ" },
    { icon: faCoins, label: "Nhận hoa hồng" },
];

export function LinkConverterHero() {
    return (
        <div className="bg-gradient-to-br from-brand-red to-brand-warm text-white px-4 py-4 rounded-t-lg">
            <h1 className="font-lexend text-base font-bold leading-tight">
                Biến link sản phẩm thành link kiếm tiền
            </h1>
            <div className="flex items-center gap-2 mt-3 flex-wrap">
                {FLOW.map((step, i) => (
                    <React.Fragment key={step.label}>
                        {i > 0 && (
                            <FontAwesomeIcon icon={faChevronRight} className="text-[10px] text-white/50" />
                        )}
                        <span className="flex items-center gap-1.5">
                            <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                                <FontAwesomeIcon icon={step.icon} className="text-xs" />
                            </span>
                            <span className="text-xs text-white/85">{step.label}</span>
                        </span>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}

function StepItem({ step, icon, color, title, desc }) {
    return (
        <div className="flex items-start gap-3">
            <div className={`${color} w-10 h-10 rounded-full flex items-center justify-center text-white shrink-0`}>
                <FontAwesomeIcon icon={icon} className="text-sm" />
            </div>
            <div>
                <p className="font-semibold text-sm">
                    <span className="text-content-3 mr-1">#{step}</span>
                    {title}
                </p>
                <p className="text-xs text-content-3 mt-0.5">{desc}</p>
            </div>
        </div>
    );
}

function UseCase({ icon, color, bg, text }) {
    return (
        <div className={`flex items-center gap-3 p-3 ${bg} rounded-xl`}>
            <FontAwesomeIcon icon={icon} className={`${color} text-lg`} />
            <span className="text-sm font-medium text-content-2">{text}</span>
        </div>
    );
}

export function LinkConverterGuide() {
    return (
        <>
            <div className="bg-surface p-4 mt-2 rounded-lg">
                <h2 className="font-bold text-base mb-4">Cách hoạt động</h2>
                <div className="flex flex-col gap-4">
                    <StepItem
                        step={1}
                        icon={faLink}
                        color="bg-brand-warm"
                        title="Dán link sản phẩm"
                        desc="Copy link sản phẩm từ Shopee, ShopeeFood, Lazada hoặc TikTok Shop và dán vào ô bên trên"
                    />
                    <StepItem
                        step={2}
                        icon={faShare}
                        color="bg-brand-coral"
                        title="Chia sẻ link mới"
                        desc="Chia sẻ link hoàn tiền lên Facebook, Zalo, Telegram hoặc group Longhousee"
                    />
                    <StepItem
                        step={3}
                        icon={faCoins}
                        color="bg-brand-red"
                        title="Nhận hoa hồng"
                        desc="Khi bạn bè mua hàng qua link, bạn nhận được hoa hồng tại Longhousee"
                    />
                </div>
            </div>

            <div className="bg-surface p-4 mt-2 rounded-lg">
                <h2 className="font-bold text-base mb-3">Dùng để làm gì?</h2>
                <div className="grid grid-cols-1 gap-2.5">
                    <UseCase
                        icon={faShoppingBag}
                        color="text-orange-500"
                        bg="bg-orange-50"
                        text="Share deal hot, mã giảm giá lên group"
                    />
                    <UseCase
                        icon={faUsers}
                        color="text-blue-500"
                        bg="bg-blue-50"
                        text="Chia sẻ link live, flash sale cho bạn bè"
                    />
                    <UseCase
                        icon={faCoins}
                        color="text-green-500"
                        bg="bg-green-50"
                        text="Kiếm thêm thu nhập từ việc chia sẻ link mua sắm"
                    />
                </div>
            </div>
        </>
    );
}
